import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Èopièi",
  "description": "",
  "published": "2006-08-04T00:00:00.000Z",
  "redirect_from": ["/blog/opii/swizec/391"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Vèeraj sem odkril nekaj odliènega, nekaj tako superbno superiornega, da se še Da Vinci skrije v osramoèen. Kot ka¾e je va Photoshopu neka stvarca, ki do sedaj v mojih oèeh ni obstajala, omogoèa namreè nastavitve obnašanja èopièev. Odlièno, kar tako, pojavi se in puf, tam je.`}</p>
    <p>{`Najva¾nejše pri tem je to kakšne vse nove mo¾nosti odpira, omogoèa res veliko. Ta strip je poskoèil v kvaliteti bolj kot poskoèi zalo velik zajec kadar zelo visoko skoèi. Efekti, za katere sedaj potrebujem le nekaj potegov z miško, drugaèe zahtevajo ure in ure dela, ki na koncu pripelje do prisiljenih in fuj efektov, tako pa so hitro in uèinkovito videti popolnoma naravno in fino.`}</p>
    <p>{`Zakaj torej nisem prej zvedel za to èudovito reè? O.o`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      